export const WORDS = [
  'birndu',
  'nakurl',
  'djukka',
  'wakbom',
  'rarrk',
  'nungan',
  'kabanj',
  'kaluk',
  'kardab',
  'ngayoy',
  'daweng',
  'wayhke',
  'weykan',
  'yimey',
  'yiyime',
  'mulbbu',
  'ngalbu',
  'bikku',
  'mahmi',
  'kayame',
  'madbun',
  'nakka',
  'kamang',
  'midbun',
  'djanay',
  'wurra',
  'kelbi',
  'bordoh',
  'djamun',
  'kurrme',
  'benbom',
  'djuwe',
  'kunwel',
  'dimhmi',
  'wukmi',
  'yingun',
  'dahme',
  'mungu',
  'morak',
  'karlba',
  'bolkan',
  'bornan',
  'kaname',
  'duninj',
  'baladj',
  'kinga',
  'benuk',
  'kunbim',
  'kabbal',
  'kakirn',
  'royhme',
  'kanna',
  'ngalu',
  'bunidj',
  'bulkay',
  'baleh',
  'bilem',
  'dumdum',
  'makka',
  'wanjh',
  'kuneke',
  'barung',
  'kundiw',
  'kunyon',
  'mawah',
  'kabore',
  'daluk',
  'rakalk',
  'kambe',
  'kunka',
  'nguni',
  'manwob',
  'yimka',
  'burlng',
  'bokenh',
  'bongka',
  'yakwon',
  'boywek',
  'kamarn',
  'bayeng',
  'djobke',
  'kunkuk',
  'bimey',
  'kilelh',
  'walay',
  'dabbe',
  'djodj',
  'djanbe',
  'kubumi',
  'borrmi',
  'bebke',
  'yameng',
  'yenyen',
  'kunkal',
  'manmak',
  'dombom',
  'kilel',
  'belbmi',
  'yakbom',
  'yiname',
  'yingan',
  'woyung',
  'royhmi',
  'ngani',
  'kundoy',
  'wamud',
  'kamkan',
  'madbom',
  'kanome',
  'yungki',
  'dukkan',
  'kunak',
  'yingu',
  'ngolin',
  'medjek',
  'malayu',
  'barlmi',
  'karrme',
  'yinani',
  'ngamed',
  'kunred',
  'ngalng',
  'kanere',
  'manwid',
  'lindji',
  'kunney',
  'yimeng',
  'buyhmi',
  'kenami',
  'biwong',
  'bokung',
  'wuymi',
  'kakih',
  'winhmi',
  'yiweng',
  'kurrih',
  'kuyal',
  'ngehmi',
  'wungmi',
  'dokmi',
  'mamumu',
  'weleyh',
  'ngabba',
  'dadjmi',
  'kanwo',
  'kakowe',
  'yikan',
  'yibmi',
  'kabun',
  'djerli',
  'yakbun',
  'kewkmi',
  'ngare',
  'kaddum',
  'yiman',
  'kanan',
  'wubarr',
  'mudbom',
  'wernh',
  'ngalke',
  'wehmi',
  'yinan',
  'bikang',
  'mimih',
  'boyen',
  'ngalmi',
  'wurrik',
  'yinome',
  'kuhri',
  'karrmi',
  'bulbbe',
  'yirrmi',
  'wabmi',
  'kalawu',
  'bokorn',
  'kunmok',
  'kunkod',
  'ngamey',
  'kunbid',
  'melmi',
  'bebmi',
  'kunboy',
  'delek',
  'kunlon',
  'djulu',
  'bolmo',
  'kokok',
  'berlu',
  'wakeng',
  'kanbun',
  'yibun',
  'bedman',
  'kurndi',
  'werrk',
  'kunkak',
  'kaneyo',
  'bawon',
  'kanmey',
  'yimre',
  'molkno',
  'manme',
  'naworo',
  'widnan',
  'kuybuk',
  'kawake',
  'nginj',
  'ngawe',
  'dadjke',
  'namak',
  'kuykme',
  'manmim',
  'kunmim',
  'durnmi',
  'yinang',
  'bambam',
  'ngawon',
  'djudme',
  'malayi',
  'yibba',
  'mannud',
  'munun',
  'mandak',
  'ngamre',
  'kubba',
  'nomeng',
  'danek',
  'nabang',
  'marla',
  'manbik',
  'dakmi',
  'bininj',
  'yerre',
  'weleng',
  'yiyame',
  'nungka',
  'namud',
  'kayeme',
  'marram',
  'dadbe',
  'bibom',
  'barrk',
  'mangi',
  'yaymi',
  'adjbud',
  'murru',
  'romak',
  'moken',
  'bulumo',
  'bakmi',
  'kured',
  'balhmi',
  'kanbom',
  'kunbak',
  'bekkan',
  'mamam',
  'namung',
  'kunwok',
  'rawon',
  'demed',
  'dolhmi',
  'barli',
  'mikan',
  'djedje',
  'yikani',
  'yiwon',
  'binang',
  'dahmi',
  'kanedi',
  'kurih',
  'djang',
  'kamre',
  'yowayh',
  'kunuka',
  'burarr',
  'wakeyi',
  'mudmud',
  'djenj',
  'manlod',
  'djerrh',
  'kankan',
  'darlk',
  'bekka',
  'warreh',
  'wamba',
  'awurd',
  'yiwake',
  'kakbi',
  'djadme',
  'njokmi',
  'kuykmi',
  'mankuk',
  'yikowe',
  'lurlmi',
  'rakul',
  'marebu',
  'bukkan',
  'nawern',
  'norne',
  'kurrid',
  'kabele',
  'dabke',
  'dilhmi',
  'larrk',
  'kurulk',
  'bawurl',
  'ngakan',
  'kaneni',
  'nawid',
  'deddel',
  'morne',
  'bulanj',
  'marne',
  'badjan',
  'kambuk',
  'wurrmi',
  'wayuk',
  'kunnud',
  'budjum',
  'kukkan',
  'kunyid',
  'bangku',
  'ngahli',
  'nayaw',
  'wulud',
  'kundad',
  'djohmi',
  'wodbun',
  'wabban',
  'birdi',
  'mandem',
  'nabiwo',
  'nakang',
  'biwudj',
  'kukun',
  'bokkan',
  'djawan',
  'loklok',
  'yawkan',
  'djudju',
  'kabuk',
  'kukak',
  'kayime',
  'djedmi',
  'djuhke',
  'nanih',
  'kabaye',
  'barra',
  'baybay',
  'yiray',
  'yibom',
  'wukme',
  'modmi',
  'kimang',
  'kunmad',
  'yimray',
  'kakkak',
  'djobmi',
  'balay',
  'djandi',
  'wabun',
  'bonomi',
  'yawoyh',
  'kamanj',
  'bameng',
  'ngard',
  'kamak',
  'yimang',
  'ngalih',
  'morlah',
  'ngabom',
  'ngakmi',
  'ngokme',
  'walabi',
  'duruk',
  'kodjok',
  'doydoy',
  'manwak',
  'kakeyo',
  'njale',
  'kunmen',
  'yibuni',
  'larrwa',
  'koroyi',
  'badbu',
  'kunih',
  'woknan',
  'nganan',
  'kebkan',
  'mankod',
  'manbu',
  'dolek',
  'kinje',
  'kanwon',
  'yeledj',
  'kunbok',
  'bidmak',
  'bukbuk',
  'djaddi',
  'mulil',
  'djabbo',
  'yawan',
  'yikeyo',
  'yiyoy',
  'lobme',
  'kunrak',
  'kangun',
  'konda',
  'kabume',
  'yabok',
  'djuhmi',
  'kunkih',
  'kunkun',
  'bimbom',
  'yekke',
  'kanewe',
  'kondah',
  'yibbun',
  'warre',
  'kawolk',
  'kunkom',
  'nakare',
  'dowkmi',
  'marlwa',
  'kurrmi',
  'kabame',
  'kabbay',
  'kanjok',
  'djunj',
  'wokmi',
  'buhmi',
  'djekmi',
  'bakki',
  'kaybun',
  'kabang',
  'wakih',
  'manbak',
  'wardi',
  'bonbon',
  'libmi',
  'yiyun',
  'wolbu',
  'koknan',
  'karung',
  'wirlam',
  'yiwong',
  'bidbom',
  'kayhmi',
  'yibaye',
  'rlobmi',
  'nameng',
  'nahnan',
  'kunkeb',
  'dirdko',
  'yiyeme',
  'kakele',
  'nahni',
  'wayhmi',
  'laddum',
  'bidbun',
  'kayhme',
  'djuymi',
  'kawob',
  'burdoh',
  'kunyil',
  'boken',
  'bedda',
  'worrno',
  'nabirl',
  'makali',
  'ngali',
  'belinj',
  'ngehke',
  'djirla',
  'ngabun',
  'wirdmi',
  'yiwam',
  'koyhbe',
  'djabel',
  'bukka',
  'madjba',
  'kebmak',
  'ngaye',
  'ngudda',
  'yikang',
  'bunje',
  'dedded',
  'dabuno',
  'kukku',
  'ngawam',
  'djord',
  'balang',
  'delkke',
  'kakan',
  'njamed',
  'kename',
  'koyek',
  'mirarr',
  'wokwon',
  'adjuh',
  'nayin',
  'walem',
  'derdmi',
  'bokko',
  'kunmud',
  'ngayo',
  'yerrih',
  'benmey',
  'djurra',
]
